import { useMemo } from "react";
import { haversine } from "../utils/mapUtils";
import { Restaurant } from "../interfaces/Catalogue";

export type ProcessedRestaurant = Restaurant & { _dist: number | null };

export const useProcessedRestaurants = (
  restaurants: Restaurant[],
  search: string,
  userLocation: { lat: number; lng: number } | null
): ProcessedRestaurant[] =>
  useMemo(() => {
    const q = search.trim().toLowerCase();
    return restaurants
      .map((r) => {
        const serverDist = (r.distance ?? 0) as number;
        let dist = serverDist > 0 ? serverDist / 1000 : null;
        if (dist === null && userLocation && r.latitude !== 0) {
          dist = haversine(userLocation.lat, userLocation.lng, r.latitude, r.longitude);
        }
        return { ...r, _dist: dist };
      })
      .filter(
        (r) =>
          !q ||
          r.nom.toLowerCase().includes(q) ||
          (r.address ?? "").toLowerCase().includes(q)
      )
      .sort((a, b) => {
        if (a.isOpen !== b.isOpen) return a.isOpen ? -1 : 1;
        if (a._dist !== null && b._dist !== null) return a._dist - b._dist;
        if (a._dist !== null) return -1;
        if (b._dist !== null) return 1;
        return 0;
      });
  }, [restaurants, search, userLocation]);